module.exports = __webpack_public_path__ + "img/crew.9276ca40.png";